/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Checkout/OrderConfirmation',[
    'global/all'
], function (Roc) {
    'use strict';

    var viewModel;

    function init(model, isImpersonationActive) {
        // customization: set order item margin property values
        model.isImpersonationActive = isImpersonationActive;
        if (isImpersonationActive) {
            Roc.OrderHelper.setOrderMargins(model);
        }
        // Customization: Add products sfsNumber to view model
        _.forEach(model.recipients,
            function (r) {
                r.shiptoId = model.shiptoId;
                _.forEach(r.items,
                    function (item) {
                        Roc.ProductHelper.setProductSFSNumber(item);
                    });
            });
        //END Customization
        Roc.UI.template('orderConfirmation-Tmp', model).then(function (renderedTemplate) {
            $('#orderConfirmationDetails').html(renderedTemplate);
        });

        viewModel = model;

        Roc.EventManager.notify(Roc.Events.cart.ORDER_CONFIRM, viewModel, true);
    };

    var OrderConfirmation = {
        init: init,
        viewModel: viewModel
    };

    Roc.Logger.debug('OrderConfirmation.js Loaded:', OrderConfirmation);

    return OrderConfirmation;
});

